import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import FeatureRow from './FeatureRow';

interface Feature {
  name: string;
  description?: string;
  starter: any;
  max: any;
  family: any;
  familyPlus?: any;
  careAddOn?: any;
}

interface FeatureCategoryData {
  name: string;
  icon?: string;
  features: Feature[];
}

interface FeatureCategoryProps {
  category: FeatureCategoryData;
  isExpanded: boolean;
  onToggle: (categoryName: string) => void;
}

const FeatureCategory = ({ 
  category, 
  isExpanded, 
  onToggle 
}: FeatureCategoryProps) => {
  return (
    <Card className="overflow-hidden">
      <CardHeader 
        className="cursor-pointer transition-colors hover:bg-muted/50 pb-4" 
        onClick={() => onToggle(category.name)}
      >
        <CardTitle className="flex items-center justify-between">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-lg">{category.name}</span>
            <Badge variant="outline" className="text-xs ml-auto sm:ml-0">
              {category.features.length} features
            </Badge>
          </div>
          <div className="flex-shrink-0">
            {isExpanded ? (
              <ChevronUpIcon className="w-5 h-5 text-muted-foreground" />
            ) : (
              <ChevronDownIcon className="w-5 h-5 text-muted-foreground" />
            )}
          </div>
        </CardTitle>
      </CardHeader>

      {isExpanded && (
        <CardContent className="pt-0">
          {/* Plan Headers - 3 columns */}
          <div className="grid grid-cols-4 gap-2 mb-6 p-4 bg-muted/30 rounded-lg">
            <div className="text-xs font-semibold text-muted-foreground">Feature</div>
            <div className="text-xs font-semibold text-center">Limited Access</div>
            <div className="text-xs font-semibold text-center">ThriveMax<br /><span className="text-muted-foreground font-normal">$29</span></div>
            <div className="text-xs font-semibold text-center">ThriveFamily<br /><span className="text-muted-foreground font-normal">$59</span></div>
          </div>

          {/* Features */}
          <div className="space-y-3">
            {category.features.map((feature, index) => (
              <FeatureRow 
                key={index}
                feature={feature}
              />
            ))}
          </div>
        </CardContent>
      )}
    </Card>
  );
};

export default FeatureCategory;
